import { useTranslation } from 'react-i18next'
import DateTimePickerComponent from '@/components/_custom/Picker/dateTimePicker/dateTimePicker'

interface ReleaseDateFieldProps {
    value: string
    onChange: (value: string) => void
    minDate: string
    maxDate: string
    className?: string
}

export default function ReleaseDateField({ value, onChange, minDate, maxDate, className }: ReleaseDateFieldProps) {
    const { t } = useTranslation()

    return (
        <DateTimePickerComponent
            value={value}
            setValue={onChange}
            onClear={() => onChange('')}
            minDate={minDate}
            maxDate={maxDate}
            className={className}
            label={t('liberationDate')}
            minuteToDisable={60}
        />
    )
}
